// extracted by mini-css-extract-plugin
export default {"container":"style_container__gSAAr","leftTopContainer":"style_leftTopContainer__+V7Jk","topContainerLeftText":"style_topContainerLeftText__pUZ8C"};